/* eslint-disable no-restricted-globals */
import { useState, useEffect } from "react";
import { supabase } from "./lib/supabase";
import { P } from "./styles/theme";
import BookingPage    from "./components/BookingPage";
import MyBookings     from "./components/MyBookings";
import FindMyBooking  from "./components/FindMyBooking";

export default function App() {
  const [session,  setSession]  = useState(undefined);
  const [mainView, setMainView] = useState('booking');

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  // Loading
  if (session === undefined) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: P.bg }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '36px', marginBottom: '12px' }}>💅</div>
          <p style={{ color: P.muted, fontSize: '14px' }}>Loading...</p>
        </div>
      </div>
    );
  }

  // My Bookings — authenticated only
  if (mainView === 'mybookings' && session) {
    return <MyBookings session={session} onBack={() => setMainView('booking')} />;
  }

  // Find My Booking — no auth required
  if (mainView === 'findbooking') {
    return <FindMyBooking onBack={() => setMainView('booking')} />;
  }

  return (
    <BookingPage
      session={session}
      onViewMyBookings={() => setMainView('mybookings')}
      onFindBooking={() => setMainView('findbooking')}
    />
  );
}
